"use client"

import { AnchorButton } from "~/components/ui/Button"
import { withTracking } from "~/components/ui/withTracking"

/** Tracked derivation of {@link AnchorButton} — reports a Google Ads event on click. */
export const TrackedAnchorButton = withTracking(AnchorButton)
